<template>
    <transition name="component-fade" mode="out-in">
        <div class="mask">
            <div class="mask_tips"></div>
            <div class="mask_in">
                <i @click="closeMask"></i>
                <p>系统提示</p>
                <span>很抱歉，當前頁面服務僅對港澳台地區用戶開放</span>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "CommonMask",
    props:{
        options: Object
    },
    data() {
        return {}
    },
    computed: {
    },
    methods: {
        closeMask: function() {
            this.$emit('closeMask');
        }
    }
};
</script>

<style lang="css" scoped>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 115;
    text-align: center;
}
.mask .mask_in{
    width: 463px;
    height: 234px;
    background: #ffffff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -117px;
    margin-left: -231.5px;
    border-radius: 20px;
    text-align: center;
}
.mask .mask_in i{
    width: 28px;
    height: 27px;
    position: absolute;
    right: 20px;
    top: 20px;
    background: url('../../static/img/close.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}
.mask .mask_in p {
    color:#ef6549;
    font-size: 22px;
    font-weight:600;
}
.mask .mask_in span {
    display: block;
    margin-top: 60px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/mask.vue